import { FC } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";
import { EventEntryInput } from "../../../reducers/states/event-management";
import CreateIncident from "../../incident-model/create-incident-model";
import { DispatchEventFeedModel } from "../../../reducers";
import EventEntryForm, { EventEntryFormMode } from "../../event-management/event-input-form";
import CloseIcon from "@mui/icons-material/Close";

interface MajorEventModalProps {
  isOpen: boolean;
  selectedEvent: EventEntryInput;
  handleClose: () => void;
}

const MajorEventModal: FC<MajorEventModalProps> = (props) => {

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.handleClose}
      fullWidth
      maxWidth="lg"
    >
      <Box sx={{
        position: "absolute",
        right: 64,
        top: 16
      }}>
        <CreateIncident
          props={{
            mostRecentSelectedEvent: {} as DispatchEventFeedModel,
          }}
        />
      </Box>

      <IconButton
        onClick={props.handleClose}
        size="large"
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle id="form-dialog-title">Event Details</DialogTitle>

      <DialogContent>
        <EventEntryForm
          props={{
            event: props.selectedEvent,
            mode: EventEntryFormMode.READ_ONLY,
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default MajorEventModal;
